import React, { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useHttp from 'utils/hooks/useHttp';
import { getMarketplaceBaseUrl, notify } from 'utils/marketplace';
import { ILoginResponse } from 'utils/hooks/http/auth.http';
import { useAppDispatch } from '../../utils/hooks/redux';
import { login } from '../../store/reducers/useSlices';
import NewLoginView from './NewLogin.view';
import { getCountryFromLocale } from 'utils/locale';
import { useTranslation } from 'react-i18next';
import { getRedirectedHref } from '../../utils/utils';
import { resetTariffs } from 'store/slices/automotor-tariff.slice';
import useIsProductionHost from 'utils/hooks/useIsProductionHost';


const NewLogin: React.FC = () => {
  const {
    getValues,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FieldValues>();

  const [isLoading, setisLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const redirectedHref = getRedirectedHref();
  const { i18n } = useTranslation();

  const dispatch = useAppDispatch();
  const http = useHttp();
  const isProductionHost = useIsProductionHost();


  useEffect(() => {
    if (localStorage.getItem('token') && localStorage.getItem('userData')) {
      navigate('/');
    }
  }, []);

  const loginHandler = () => {


    const protocol = window.location.protocol; // "https:" sau "http:"
    const host = window.location.host;


    if (redirectedHref) {
      const redirectUrl = encodeURIComponent(`${protocol}//${host}`) + redirectedHref;

      console.log('redirectUrl', redirectUrl);

      window.location.href = getMarketplaceBaseUrl() + '/social-auth/microsoft?redirect_url=' + redirectUrl;
    } else {
      window.location.href = getMarketplaceBaseUrl() + '/social-auth/microsoft';
    }
  };


  const onSubmit = async () => {
    setisLoading(true);

    const values = getValues();

    const param = { password: values.password ?? '', username: values.email ?? '' };


    http.auth
      .login(param)
      .then((res: ILoginResponse) => {
        localStorage.setItem('token', res.token);

        localStorage.setItem('userData', JSON.stringify(res.user));
        dispatch(login(res.user));
        const country = getCountryFromLocale(i18n);

        if (country) {
          const locale = `${res.user.language}-${country.id}`;

          localStorage.setItem('locale', locale);
          i18n.changeLanguage(locale);
        }

        if(isProductionHost){
          localStorage.setItem('showMigrationModalAfterLogin', 'true');
        }
        
        if (redirectedHref) {
          const redirectedUrl = decodeURIComponent(redirectedHref);

          const queryIndex = redirectedUrl.indexOf('?');
          const queryString = queryIndex !== -1 ? redirectedUrl.substring(queryIndex + 1) : '';

          const params = new URLSearchParams(queryString);

          if (params.get('select_client') === 'true' && params.get('client_id')) {
            const clientId = Number(params.get('client_id'));

            handleSelectClient(clientId);
          } else {
            window.location.replace(redirectedUrl);
          }
        } else {
          
          navigate('/');
        }

      })
      .catch((err) => {
        notify(err.response.data.message);
      })
      .finally(() => {
        setisLoading(false);
      });
  };

  const handleSelectClient = async (clientId: number) => {

    localStorage.setItem('clientId', String(clientId));
    await http.selectClient.saveClientForSeller(clientId);
    const user = await http.user.infoUser();

    localStorage.setItem('userData', JSON.stringify(user.data));
    dispatch(login(user.data));
    dispatch(resetTariffs());
    const linkParams = new URLSearchParams(window.location.search);

    const redirectedHref = linkParams.get('redirectedHref');

    navigate(redirectedHref ? decodeURIComponent(redirectedHref) : '/');
  };

  return (
    <NewLoginView handleSubmit={handleSubmit} onSubmit={onSubmit} register={register} errors={errors} isLoading={isLoading} loginHandler={loginHandler}></NewLoginView>
  );
};

NewLogin.displayName = 'NewLogin';

export default NewLogin;
